import MarketPlaceCards from "./componenets/MarketPlaceCards";

const MarketPlacePage = () => {
    return (
        <MarketPlaceCards />
    );
};

export default MarketPlacePage;